import { render } from "./MyMenu.vue?vue&type=template&id=81ddc6ce&scoped=true"
import script from "./MyMenu.vue?vue&type=script&lang=js"
export * from "./MyMenu.vue?vue&type=script&lang=js"

import "./MyMenu.vue?vue&type=style&index=0&id=81ddc6ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ddc6ce"]])

export default __exports__